import getNeedsDashJs from "selectors/getNeedsDashJs";
import { createSelector } from "reselect";

const getDashJsLoadComplete = (state) => state.loading.dashJsLoadComplete;

const getWaitingForDashJs = createSelector(
  [getDashJsLoadComplete, getNeedsDashJs],
  (dashJsLoadComplete, needsDashJs) => needsDashJs && !dashJsLoadComplete,
);

export default getWaitingForDashJs;
